import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Layout/Navbar';
import TabAnimationMockup from './TabAnimationMockup';
import './LandingPageNew.css';

const LandingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="roofing-assist-landing-new">
      <Navbar theme="light" />

      {/* Hero Section Container */}
      <div className="container">


        {/* Hero Section */}
        <div className="hero">
          <div className="hero-left">
            <div className="eyebrow" style={{ fontFamily: "'Consolas', monospace", fontSize: '11px' }}>The Command Center for Roofing Operations</div>
            <h1 className="headline">
              Roofing companies don’t need more tools.<br />
              <em>They need<br />control.</em>
            </h1>
            <p className="subtext">
              Other roofing platforms record what already happened. RoofingAssist.AI uses intelligence to see what’s coming next and puts jobs in front of you before anyone else even knows to look.
            </p>
            <div className="cta-group">
              <Link to="/book" className="btn-primary">Book a Call &rarr;</Link>
              <a href="#command-center" className="btn-secondary">See the command center</a>
            </div>
            <p className="post-cta-text">You didn't get into roofing to manage software!</p>
          </div>

          {/* Hero Right Panel Mockup */}
          <div className="hero-right" id="command-center">
            <div className="mockup">
              <div className="mockup-header">
                <div className="window-controls">
                  <div className="control-dot dot-red"></div>
                  <div className="control-dot dot-yellow"></div>
                  <div className="control-dot dot-green"></div>
                </div>
                <div className="mockup-title">COMMAND CENTER</div>
                <div className="live-indicator"><div className="live-dot"></div>LIVE</div>
              </div>
              
              <div className="mockup-body">
                <div className="metrics-row">
                  <div className="metric">
                    <div className="metric-label">Open Jobs</div>
                    <div className="metric-value orange">47</div>
                    <div className="metric-delta delta-white">+8 this week</div>
                  </div>
                  <div className="metric">
                    <div className="metric-label">Month Revenue</div>
                    <div className="metric-value">$284k</div>
                    <div className="metric-delta delta-green">&uarr; 12% vs last mo</div>
                  </div>
                  <div className="metric">
                    <div className="metric-label">Avg Margin</div>
                    <div className="metric-value">22%</div>
                    <div className="metric-delta delta-yellow">&darr; 1pt vs target</div>
                  </div>
                </div>
                
                <div className="section-divider"></div>
                
                <div className="storm-radar-section">
                  <div className="storm-radar-header">
                    <div className="section-title">Storm Radar Live</div>
                    <a href="#radar" className="pill-orange-outline">14 properties flagged</a>
                  </div>
                  
                  <div className="radar-box">
                    <div className="radar-label">Coverage Area</div>
                    <div className="radar-graphic">
                      <div className="radar-dot" style={{ top: '25%', left: '35%' }}></div>
                      <div className="radar-dot" style={{ top: '65%', left: '65%', opacity: 0.6 }}></div>
                      <div className="radar-dot" style={{ top: '45%', left: '85%', opacity: 0.9 }}></div>
                      <div className="radar-dot" style={{ top: '80%', left: '40%', opacity: 0.4 }}></div>
                    </div>
                  </div>
                  
                  <Link to="/login" className="alert-box">
                    <div className="alert-left">
                      <div className="alert-icon">⚡</div>
                      <div>
                        <div className="alert-title">Hail event NW sector</div>
                        <div className="alert-desc">3 existing customers in zone - 11 new properties</div>
                      </div>
                    </div>
                    <span className="alert-link">View all &rarr;</span>
                  </Link>
                </div>
                
                <div className="section-divider"></div>
                
                <div className="recent-jobs-section">
                  <div className="section-title" style={{ marginBottom: '10px' }}>Recent Jobs</div>
                  
                  <div className="jobs-list">
                    <div className="job-row">
                      <div>
                        <div className="job-title">147 Maple Dr &mdash; Hail Damage</div>
                        <div className="job-desc">Estimate sent - $14,200</div>
                      </div>
                      <div className="pill-status pill-blue">New Lead</div>
                    </div>
                    <div className="job-row">
                      <div>
                        <div className="job-title">2204 Ridgeline Ave &mdash; Full Replace</div>
                        <div className="job-desc">Crew B - Thu Apr 10</div>
                      </div>
                      <div className="pill-status pill-orange">In Progress</div>
                    </div>
                    <div className="job-row">
                      <div>
                        <div className="job-title">88 Westbrook Ct &mdash; Insurance</div>
                        <div className="job-desc">Paid - margin 30%</div>
                      </div>
                      <div className="pill-status pill-green">Complete</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> {/* Close Container */}


      {/* THE SHIFT SECTION */}
      <div className="shift-wrapper" id="win">
        <div className="container">
          <div className="the-shift">
            {/* Browser Micro-Animation */}
            <div className="shift-right">
              <TabAnimationMockup />
            </div>

            {/* Feature Description Text */}
            <div className="shift-left">
              <div className="eyebrow">THE SHIFT</div>
              <h2 className="headline">From chaos to control.</h2>
              <p>RoofingAssist.AI replaces the disconnected tools you're juggling and turns them into one intelligent system that actually moves your business forward.</p>
              <p>Instead of toggling between platforms, everything works together.</p>
              
              <div className="shift-list">
                <div className="shift-list-item"><div className="check-icon">&#10003;</div> CRM and pipeline tracking</div>
                <div className="shift-list-item"><div className="check-icon">&#10003;</div> Estimating tools</div>
                <div className="shift-list-item"><div className="check-icon">&#10003;</div> Measurement reports</div>
                <div className="shift-list-item"><div className="check-icon">&#10003;</div> Self scheduling</div>
                <div className="shift-list-item"><div className="check-icon">&#10003;</div> Bookkeeping</div>
                <div className="shift-list-item"><div className="check-icon">&#10003;</div> Financial reporting &amp; costing</div>
                <div className="shift-list-item"><div className="check-icon">&#10003;</div> Marketing outreach</div>
              </div>
              
              <div className="shift-conclusion">
                One command center. Fully connected. Built to drive revenue.
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* THE PLATFORM SECTION */}
      <div className="the-platform" id="pricing">
        <div className="container">
          <div className="platform-eyebrow">THE PLATFORM</div>
          <h2 className="platform-headline">Every part of the roofing operation. Connected.</h2>
          <p className="platform-text">RoofingAssist.AI covers the full operation, from first contact to final payment. Every part is built for roofing. Everything stays connected.</p>
          <div className="platform-divider"></div>
          
          <div className="platform-grid">
            <div className="platform-box">
              <div className="eyebrow">LEAD NURTURE</div>
              <h3>Every lead gets followed up. Every time.</h3>
              <p>When a contact comes in, RoofingAssist.AI tracks it, prioritizes it, and makes sure it doesn't sit. Smart follow-ups go out on their own. Your pipeline stays warm without someone manually working it.</p>
              <ul className="platform-box-list">
                <li>Conversation Hub &mdash; texts, emails, calls in one place</li>
                <li>Automated follow-up sequences</li>
                <li>Lead prioritization based on recency and value</li>
                <li>Self-scheduling &mdash; contacts book directly to your calendar</li>
              </ul>
            </div>

            <div className="platform-box">
              <div className="eyebrow">JOB PIPELINE</div>
              <h3>Every job tracked from signed contract to closed out.</h3>
              <p>The pipeline shows where every job stands &mdash; not because you updated it manually, but because the system updates as work happens. When a job is approved, materials get ordered.</p>
              <ul className="platform-box-list">
                <li>Live job status &mdash; every stage visible in real time</li>
                <li>Materials ordered automatically on approval</li>
                <li>Field app &mdash; photos, notes, updates from the job</li>
                <li>Job details accessible before work starts, not after</li>
              </ul>
            </div>

            <div className="platform-box">
              <div className="eyebrow">ESTIMATING</div>
              <h3>Quote on the spot. Win the job before you leave the driveway.</h3>
              <p>Pitch, square footage, materials, waste factor, labor, and margin &mdash; calculated instantly. No calls back to the office. No waiting on measurement reports. Every estimate is accurate.</p>
              <ul className="platform-box-list">
                <li>Instant estimates from roof measurements</li>
                <li>Material cost, labor, waste factor, profit margin</li>
                <li>Property intelligence &mdash; roof age, permit history, risk</li>
                <li>Consistent pricing across every rep</li>
              </ul>

              {/* Sample Reports Download Boxes */}
              <div style={{ display: 'flex', gap: '12px', marginTop: '20px', flexWrap: 'wrap' }}>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a href="#" className="sample-report-box" style={{ flex: 1, minWidth: '140px', display: 'flex', alignItems: 'center', gap: '10px', background: 'rgba(255, 255, 255, 0.03)', border: '1px solid rgba(255, 255, 255, 0.08)', borderRadius: '6px', padding: '12px', textDecoration: 'none', color: '#ffffff', transition: 'all 0.3s ease' }}>
                  <div className="report-icon" style={{ color: '#d45c1a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', flexShrink: 0 }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                      <polyline points="7 10 12 15 17 10"></polyline>
                      <line x1="12" y1="15" x2="12" y2="3"></line>
                    </svg>
                  </div>
                  <div>
                    <div style={{ fontSize: '9px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#8abecc' }}>RAPID REPORT</div>
                    <div style={{ fontSize: '11.5px', fontWeight: 600, color: '#ffffff', marginTop: '1px' }}>Sample PDF &darr;</div>
                  </div>
                </a>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a href="#" className="sample-report-box" style={{ flex: 1, minWidth: '140px', display: 'flex', alignItems: 'center', gap: '10px', background: 'rgba(255, 255, 255, 0.03)', border: '1px solid rgba(255, 255, 255, 0.08)', borderRadius: '6px', padding: '12px', textDecoration: 'none', color: '#ffffff', transition: 'all 0.3s ease' }}>
                  <div className="report-icon" style={{ color: '#d45c1a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', flexShrink: 0 }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                      <polyline points="7 10 12 15 17 10"></polyline>
                      <line x1="12" y1="15" x2="12" y2="3"></line>
                    </svg>
                  </div>
                  <div>
                    <div style={{ fontSize: '9px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#8abecc' }}>PRECISE REPORT</div>
                    <div style={{ fontSize: '11.5px', fontWeight: 600, color: '#ffffff', marginTop: '1px' }}>Sample PDF &darr;</div>
                  </div>
                </a>
              </div>
            </div>

            <div className="platform-box">
              <div className="eyebrow">COLLECTIONS &amp; FINANCIALS</div>
              <h3>Get paid faster. Know where every dollar went.</h3>
              <p>Payment reminders go out before and after due dates &mdash; automatically. Invoices, payments, and expenses sync without anyone touching them. Commissions and pay are calculated easily.</p>
              <ul className="platform-box-list">
                <li>Automated payment reminders &mdash; before and after due</li>
                <li>Financial sync &mdash; invoices, payments, expenses</li>
                <li>Crew pay and commission calculated automatically</li>
                <li>Cash flow visibility across all open jobs</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* HOW INTELLIGENCE WORKS SECTION */}
      <div className="intelligence-section">
        <div className="container">
          <div className="intelligence-header">
            <div className="intelligence-eyebrow">HOW INTELLIGENCE WORKS HERE</div>
            <h2 className="intelligence-headline">Roofing intelligence<br />that works in the background.</h2>
            <p className="intelligence-text">The best technology doesn’t replace your experience. It supports it. RoofingAssist.AI applies intelligence where roofing companies lose the most time: missed opportunities, manual workflows, disconnected systems, and delayed communication. The goal is simple: fewer blind spots, better visibility, and stronger decision-making.</p>
            <div className="intelligence-divider"></div>
          </div>

          <table className="intelligence-table">
            <thead>
              <tr>
                <th className="intel-header-left">CAPABILITY</th>
                <th className="intel-header-right">WHAT THAT MEANS</th>
              </tr>
            </thead>
            <tbody>
              {/* Row 1 */}
              <tr>
                <td className="intel-col-left">
                  <div className="eyebrow">MEASUREMENT &amp; REPORTS</div>
                  <h3>Roof data calculated before you set foot on the property.</h3>
                </td>
                <td className="intel-col-right">
                  RoofingAssist.AI pulls pitch, square footage, structure, permit history, and roof age from property data &mdash; automatically. You walk into every conversation already knowing more than the homeowner does.
                </td>
              </tr>
              {/* Row 2 */}
              <tr>
                <td className="intel-col-left">
                  <div className="eyebrow">ESTIMATING</div>
                  <h3>Accurate estimates in the time it used to take to find a pen.</h3>
                </td>
                <td className="intel-col-right">
                  Material cost, labor, waste factor, and profit margin &mdash; calculated from the roof data, instantly. Every rep quotes the same way. No underbidding because someone rushed the math.
                </td>
              </tr>
              {/* Row 3 */}
              <tr>
                <td className="intel-col-left">
                  <div className="eyebrow">PROSPECTING</div>
                  <h3>Know which properties are worth your time before you knock.</h3>
                </td>
                <td className="intel-col-right">
                  Property Intelligence pulls roof age, permit records, risk indicators, and ownership data for every address in your market. You know which houses are due, and which are worth the conversation.
                </td>
              </tr>
              {/* Row 4 */}
              <tr>
                <td className="intel-col-left">
                  <div className="eyebrow">LEAD NURTURE</div>
                  <h3>Follows up for you. So the lead doesn't go cold while you're on a roof.</h3>
                </td>
                <td className="intel-col-right">
                  When a contact comes in, the system tracks it, scores it by recency and engagement, and sends follow-ups on your behalf. Texts, emails, and callbacks &mdash; timed and sequenced automatically.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* SITE FOOTER CTA */}
      <footer className="site-footer" id="book">
        <div className="container">
          <div className="sf-eyebrow">READY WHEN YOU ARE</div>
          <h2 className="sf-headline"><strong>One Call.</strong><br /><span><strong>See the operating system live.</strong></span></h2>
          <p className="sf-desc">No pitch deck. No pressure. We walk you through your operations, show you exactly how the radar coordinates, and let you decide if it's worth the switch.</p>
          <Link to="/book" className="sf-btn">Book a Call &rarr;</Link>
        </div>
      </footer>

      {/* Credits */}
      <div className="bottom-credits">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} RoofingAssist.AI. All rights reserved.</p>
          <div style={{ marginTop: '10px' }}>
            <Link to="/" className="active">Home</Link>
            <Link to="/why-we-win">Why We Win</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
